import { DrEntity } from './dr-entity';
import { ExportStreamOptions } from './export-stream-options';
import { OrderedCodeSet } from './ordered-code-set';
import { TaggedEntity } from './tagged-entity';
import { ViewType } from './view';
import { DrObject, DrObjectType } from './dr-object';

export enum ExportState {
    OPEN = 'OPEN',
    STAGED = 'STAGED',
    EXPORTED = 'EXPORTED',
    CODING = 'CODING',
    CODING_COMPLETED = 'CODING_COMPLETED',
    EMPTY = 'EMPTY'
}

export enum NearDuplicateState {
    INCOMPLETE = 'INCOMPLETE',
    COMPLETE = 'COMPLETE'
}

export enum ReviewSetState {
    AVAILABLE = 'AVAILABLE',
    REBUILDING = 'REBUILDING'
}

export class ExportStream extends DrEntity {
    name: string;
    description: string;
    documentCount: number;
    childViewCount: number;
    viewType: ViewType;
    taggedEntityList: Array<TaggedEntity>;
    createdBy: string;
    createdOn: number;
    sourceViewHandle: string;
    deDupeDocumentCount: number;
    priority: number;
    archived: boolean;
    orderedCodeSets: Array<OrderedCodeSet>;
    state: ExportState;
    nearDuplicateState: NearDuplicateState;
    options: ExportStreamOptions;
    childVolumesCount: number;
    hidden: boolean;
    reviewState: ExportState;
    reviewStream: boolean;
    currentReviewSetState: ReviewSetState;

    // off-model display values
    stateDisplay: string;

    constructor(value?: Partial<ExportStream>) {
        super(value);
        if (value) {
            if (value.taggedEntityList) {
                value.taggedEntityList = value.taggedEntityList.map(tag => new TaggedEntity(tag));
            }
            if (value.options) {
                value.options = new ExportStreamOptions(value.options);
            }
            if (value.state) {
                switch (value.state) {
                    case ExportState.OPEN: value.stateDisplay = 'Open'; break;
                    case ExportState.STAGED: value.stateDisplay = 'Staged'; break;
                    case ExportState.EXPORTED: value.stateDisplay = 'Exported'; break;
                    case ExportState.CODING: value.stateDisplay = 'Coding'; break;
                    case ExportState.CODING_COMPLETED: value.stateDisplay = 'Coding Completed'; break;
                    case ExportState.EMPTY: value.stateDisplay = 'Empty'; break;
                }
            }
            Object.assign(this, value);
        }
    }
}

export class ExportStreamViewModel extends DrObject {

    model: Partial<ExportStream>;
    original: Partial<ExportStream>;

    constructor(value?: Partial<ExportStream>) {
        super(DrObjectType.EXPORT_STREAM);

        if (value) {
            this.model = value;
            if (this.model.description == null) {
                this.model.description = '';
            }
        }

        if (this.model) {
            this.original = new ExportStream(this.model);
        }
    }
}

